var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSchedulerCalendar = function SvgSchedulerCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.509,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#264D6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.981 6.956h1.59v1.59h-1.59zM9.938 6.956h1.59v1.59h-1.59zM7.619 6.956h1.59v1.59h-1.59zM2.981 9.441h1.59v1.59h-1.59zM7.619 9.441h1.59v1.59h-1.59zM5.3 9.441h1.59v1.59H5.3zM9.938 11.925h1.59v1.59h-1.59zM7.619 11.925h1.59v1.59h-1.59zM5.3 11.925h1.59v1.59H5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.982 1.72h-1.293v1.24a.845.845 0 0 1-.85.839H9.152a.845.845 0 0 1-.85-.84V1.72H6.206v1.228c0 .47-.385.85-.859.85h-1.67a.856.856 0 0 1-.858-.85V1.72H1.525A1.52 1.52 0 0 0 0 3.231V14.49A1.52 1.52 0 0 0 1.525 16h11.457a1.52 1.52 0 0 0 1.527-1.511V3.23a1.52 1.52 0 0 0-1.527-1.51Zm.434 12.74c0 .267-.18.447-.447.447H1.54c-.267 0-.447-.18-.447-.447V5.565h12.323v8.895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.677 3.203h1.669a.256.256 0 0 0 .256-.254V.64c0-.353-.29-.64-.646-.64h-.89a.644.644 0 0 0-.645.64V2.95c0 .14.115.254.256.254ZM9.151 3.203h1.689c.135 0 .246-.11.246-.244V.63A.634.634 0 0 0 10.45 0h-.91a.634.634 0 0 0-.635.63V2.96c0 .135.11.244.246.244Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchedulerCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheduler_calendar.c9744ba3.svg";
export { ForwardRef as ReactComponent };